import { z } from "zod";
import { DraftedPatientEducationSchema, PatientEducationResponseSchema, PatientInstructionPlanActionSchema, } from "./encounter-documentation.js";
import { IdempotencyKeySchema, IdSchema, IsoDateTimeSchema, Sha256Schema } from "./primitives.js";
export const PatientEducationSectionSchema = z.enum([
    "whatWeFound",
    "careInstructions",
    "medicationInstructions",
    "returnPrecautions",
    "emergencyPrecautions",
    "followUp",
]);
/** Complete section text, including deliberate line breaks. Empty text is an intentional deletion. */
export const PatientEducationEditsSchema = z.partialRecord(PatientEducationSectionSchema, z.string().max(12_000));
export const PatientEducationDraftInputSchema = z
    .object({
    source: DraftedPatientEducationSchema,
    actions: z.array(PatientInstructionPlanActionSchema).min(1).max(20),
    inputHash: Sha256Schema,
    edits: PatientEducationEditsSchema.default({}),
})
    .strict();
export const PatientEducationHeaderSchema = z
    .object({
    patientName: z.string().min(1).max(160),
    dateOfBirth: z.string().date(),
    mrn: z.string().max(80),
    clinicianName: z.string().min(1).max(160),
    clinicName: z.string().min(1).max(200),
    clinicContact: z.string().max(500),
})
    .strict();
/**
 * plan: the visit plan's handout, issued with Sign & create orders. adhoc: a handout made from the
 * Plan heading (EXECDEV-251), independent of the note and issuable after the note is signed.
 */
export const PatientEducationDraftOriginSchema = z.enum(["plan", "adhoc"]);
export const PatientEducationDraftSchema = PatientEducationDraftInputSchema.extend({
    id: IdSchema,
    tenantId: IdSchema,
    siteId: IdSchema,
    patientId: IdSchema,
    encounterId: IdSchema,
    version: z.number().int().positive(),
    status: z.enum(["draft", "executed", "discarded"]),
    /** Present only on an ad-hoc handout (EXECDEV-251); absent means the plan's handout. */
    origin: z.literal("adhoc").optional(),
    contentHash: Sha256Schema,
    header: PatientEducationHeaderSchema,
    serviceDate: IsoDateTimeSchema,
    createdBy: IdSchema,
    updatedBy: IdSchema,
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
    executedBy: IdSchema.nullable(),
    executedAt: IsoDateTimeSchema.nullable(),
}).strict();
export const SavePatientEducationDraftRequestSchema = z
    .object({
    expectedVersion: z.number().int().nonnegative(),
    draft: PatientEducationDraftInputSchema,
    idempotencyKey: IdempotencyKeySchema,
})
    .strict();
export const PatientEducationDraftTransitionSchema = z
    .object({
    expectedVersion: z.number().int().positive(),
    expectedContentHash: Sha256Schema,
    idempotencyKey: IdempotencyKeySchema,
})
    .strict();
export const PatientEducationDraftEnvelopeSchema = z
    .object({
    draft: PatientEducationDraftSchema,
    document: PatientEducationResponseSchema,
})
    .strict();
//# sourceMappingURL=patient-education-drafts.js.map